import { render, staticRenderFns } from "./AssetTypeInventoryDetailsView.vue?vue&type=template&id=05dc3904"
import script from "./AssetTypeInventoryDetailsView.vue?vue&type=script&lang=js"
export * from "./AssetTypeInventoryDetailsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports